export default "__VITE_ASSET__CZOpTWpz__"